import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import logobottom from './../assets/img/1_1.png';
import { SideNav, Chevron, Icon } from 'react-side-nav';
import 'react-side-nav/dist/themes.css';
import { CommonGet } from '../utils/CommonFetch';
// import config from "react-global-configuration";
// import CryptoJS from "crypto-js";

// var serviceUrl = config.get('apidomain');

const menuItems = [

    {
        id: 100,
        label: 'Master Data',
        icon: 'fas fa-database',
        className: 'bold',
        //expanded: 'false',
        items: [
            {
                id: 1,
                label: 'Branch',
                icon: 'fas fa-file',
                link: '/masterdata/branch/Index',
                className: 'active',
            },
            {
                id: 2,
                label: 'Terminal Maintenance',
                icon: 'fas fa-file',
                link: '/mobilebanking/terminalmaintenance/index',
            }

        ]
    },
    {
        id: 200,
        label: 'Mobile Management',
        icon: 'fas fa-mobile',

        items: [
            {
                id: 1,
                label: 'Mobile Vendors',
                icon: 'fas fa-file',
                link: '/mobilebanking/mobilevendors/Index',

            },
            {
                id: 2,
                label: 'Mobile Manufacturer',
                icon: 'fas fa-file',
                link: '/mobilebanking/mobilemanufacturers/index',
            },
            {
                id: 3,
                label: 'Mobile Model',
                icon: 'fas fa-file',
                link: '/mobilebanking/mobilemodels/index',
            },
            {
                id: 4,
                label: 'Mobile',
                icon: 'fas fa-file',
                link: '/mobilebanking/mobile/index',
            }

        ]
    },
    {
        id: 825,
        label: 'SIM Management',
        icon: 'fas fa-microchip',

        items: [
            {
                id: 1,
                label: 'Network Operator',
                icon: 'fas fa-file',
                link: '/mobilebanking/networkoperator/Index',
            },
            {
                id: 2,
                label: 'SIM',
                icon: 'fas fa-file',
                link: '/mobilebanking/sim/index',
            }

        ]
    },
    {
        id: 400,
        label: 'Mobile Banking',
        icon: 'fas fa-credit-card',

        items: [
            {
                id: 1,
                label: 'Mobile Package Creation',
                icon: 'fas fa-file',
                link: '/mobilebanking/mobilepackage/index',
            },
            {
                id: 2,
                label: 'Mobile Package Maintenance',
                icon: 'fas fa-file',
                link: '/mobilebanking/PackageUserMaintain/Index',
            },
            {
                id: 3,
                label: 'Teller Request List',
                icon: 'fas fa-file',
                link: '/mobilebanking/tellerrequestlist/index',
            },
            {
                id: 4,
                label: 'Transaction Search',
                icon: 'fas fa-file',
                link: '/mobilebanking/transactionsearch/index',
            },

        ]
    },
    {
        id: 500,
        label: 'Maintain Roles',
        icon: 'fas fa-address-card',

        items: [
            {
                id: 1,
                label: 'Maintain User Roles',
                icon: 'fas fa-file',
                link: '/mobilebanking/rolemaintain/index',
            }
        ]
    },
    {
        id: 600,
        label: 'Admin',
        icon: 'fas fa-address-card',

        items: [
            {
                id: 1,
                label: 'Create User',
                icon: 'fas fa-file',
                link: '/admin/createuser',
            },
            {
                id: 2,
                label: 'Edit User',
                icon: 'fas fa-file',
                link: '/admin/edituser/index',
            }

        ]
    },
    {
        id: 700,
        label: 'Hooks',
        icon: 'fas fa-address-card',

        items: [
            {
                id: 1,
                label: 'Test',
                icon: 'fas fa-file',
                link: '/hooks/test',
            }
        ]
    }
];

const newMenu = [
    {
        id: 100,
        label: 'Master Data',
        icon: 'fas fa-database',
        className: 'bold',
        //expanded: 'false',
        items: [
            {
                id: 1,
                label: 'Group',
                icon: 'fas fa-file',
                link: '/groups',
                className: 'active',
            },
            {
                id: 2,
                label: 'Factory',
                icon: 'fas fa-file',
                link: '/factories',
            },
            {
                id: 3,
                label: 'Route',
                icon: 'fas fa-file',
                link: '/routes',
            },
            {
                id: 4,
                label: 'Estate',
                icon: 'fas fa-file',
                link: '/estates',
            },
            {
                id: 5,
                label: 'OperationCard',
                icon: 'fas fa-file',
                link: '/operationcards',
            },
            {
                id: 6,
                label: 'Division',
                icon: 'fas fa-file',
                link: '/division',
            },
            {
                id: 7,
                label: 'Factory Items',
                icon: 'fas fa-file',
                link: '/factoryitems',
            }
        ]
    },
	{
        id: 101,
        label: 'Deduction',
        icon: 'fas fa-database',
        className: 'bold',
        //expanded: 'false',
        items: [
            {
                id: 1,
                label: 'Deduction',
                icon: 'fas fa-file',
                link: '/deduction',
                
            }, {
                id: 2,
                label: 'Task Template',
                icon: 'fas fa-file',
                link: '/tasktemplate',
            },
            {
                id: 3,
                label: 'Card Upload',
                icon: 'fas fa-file',
                link: '/cardupload',
            },
            {
                id: 4,
                label: 'Collection Point',
                icon: 'fas fa-file',
                link: '/collectionpoint',
            } , {
                id: 5,
                label: 'Field',
                icon: 'fas fa-file',
                link: '/field',
            }

        ]
    }
]


const NavLink1 = props => (<NavLink {...props}><i className={`fa ${props.icon}`} />{props.label}</NavLink>);

export class NavMenu extends Component {
    state = {
        activate: true,
        screenId: [],
        navList: []
    };

    clickActivate = () => {
        const activate = '';

        this.setState({ activate });
    }
    displayName = NavMenu.name

    //   componentWillMount() {

    //     var user = sessionStorage.getItem('TipsUser');
    //     var obj = JSON.parse(user);

    //     var decryptedBytes = CryptoJS.AES.decrypt(obj.content.toString(), "IL0V#M7ELLE4");
    //     var decryptedData = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));

    //     fetch(serviceUrl+'/api/Permission/CheckPermission?userId='+ decryptedData.userId +'&screenId=', {
    //         headers: new Headers({
    //             'Authorization': 'Bearer ' + window.access_token,
    //             'Access-Control-Allow-Methods': '*',
    //             'Accept-Language': 'en-US'
    //         })
    //     })
    //     .then(response => response.json())
    //     .then(data => {

    //         })
    //     }


    generateNav = () => {
        //console.log(this.props.navList);
        return (
            <SideNav
                //items={this.props.menuData}
                items={newMenu}
                activeItem={this.state.activate}
                linkComponent={NavLink1}
                chevronComponent={Chevron}
                iconComponent={Icon}
            />
        )
    }

    render() {
        let navList = this.generateNav();
        return (
            {/*  
            <div className="sidebar" id="side" data-color="base-color">

                <div className="logo">
                    <a href="index.html">
                        <img src={logo} alt="DFCC Bank" title="DFCC Bank" />
                    </a>
                </div>

               <div className="sidebar-wrapper ps-container ps-theme-default ps-active-y" data-ps-id="383737bb-5253-2b41-5996-139d4709936d">

                    {navList}
                    </div>
                    <div className="bottom-logo">
                        <img src={logobottom} alt="Tips" className="blogo" title="Tips" />
                </div>
              
                </div>
             */}
        );
    }
}
